var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftEdge = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 4 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0C2.04 1.65 3.36 4.17 3.36 7C3.36 9.83 2.05 12.35 0 14H4.06V0H0Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_6"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 14,
  fill: "white"
})))));
export default SvgLeftEdge;